import React, { useState } from 'react';
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Collapse,
  Typography,
  Paper,
} from '@mui/material';
import { ExpandLess, ExpandMore } from '@mui/icons-material';
import { makeStyles, createStyles } from '@mui/styles';
import CategoryModal from './Modal';

const useStyles = makeStyles(() =>
  createStyles({
    table: {
      width: '100%',
    },
    tableCell: {
      padding: '8px !important',
      overflow: 'hidden',
      minWidth: '50px',
      maxWidth: '180px',
      whiteSpace: 'nowrap',
      fontSize: '14px !important', // Reduced font size
    },
    tableCellTasa: {
      padding: '8px !important',
      overflow: 'hidden',
      maxWidth: '50px',
      whiteSpace: 'nowrap',
      fontSize: '14px !important', // Reduced font size
      textAlign: 'right',
    },
    tableCellNames: {
      padding: '8px !important',
      overflow: 'hidden',
      maxWidth: '80px',
      whiteSpace: 'nowrap',
      fontSize: '14px !important', // Reduced font size
    },
    tableContainer: {
      border: '1px solid #e0e0e0',
      borderRadius: '10px',
    },
    tableBody: {
      backgroundColor: '#ffffff',
    },
    textField: {
      fontSize: '14px !important',
      padding: '8px !important',
    },
    textFieldAutocomplete: {
      fontSize: '14px !important',
      padding: '0px !important',
      minWidth: '120px !important',
    },
    iconButton: {
      padding: '5px',
    },
    clickableRow: {
      cursor: 'pointer',
      '&:hover': {
        backgroundColor: '#f5f5f5',
      },
    },
  }),
);

const DailyBookEntriesTable = (props: any) => {
  const { entries } = props;
  const [expandedDays, setExpandedDays] = useState<Record<number, boolean>>({});
  const [expandedCategories, setExpandedCategories] = useState<
    Record<string, boolean>
  >({});
  const classes = useStyles();
  const [modalOpen, setModalOpen] = useState(false);
  const [selectedCategory, setSelectedCategory] = useState<any>(null);

  const handleCloseModal = () => {
    setModalOpen(false);
    setSelectedCategory(null);
  };

  const toggleDay = (dayIndex: number) => {
    setExpandedDays((prev) => ({ ...prev, [dayIndex]: !prev[dayIndex] }));
  };

  const toggleCategory = (key: string) => {
    setExpandedCategories((prev) => ({ ...prev, [key]: !prev[key] }));
  };

  const handleRowClick = (row: any) => {
    setSelectedCategory(row);
    setModalOpen(true);
  };

  return (
    <TableContainer className={classes.tableContainer}>
      <Table className={classes.table}>
        <TableHead>
          <TableRow>
            <TableCell>Fecha</TableCell>
            <TableCell></TableCell>
          </TableRow>
        </TableHead>
        <TableBody className={classes.tableBody}>
          {entries.map((day: any, dayIndex: number) => (
            <React.Fragment key={dayIndex}>
              {/* Nivel 1: Día */}
              <TableRow
                hover
                className={classes.clickableRow}
                onClick={() => toggleDay(dayIndex)}
                style={{ cursor: 'pointer', backgroundColor: expandedDays[dayIndex] ? '#f5f5f5' : undefined }}
              >
                <TableCell className={classes.tableCell}>{day.date}</TableCell>
                <TableCell
                  className={classes.tableCell}
                  style={{ textAlign: 'right' }}
                >
                  {expandedDays[dayIndex] ? <ExpandLess /> : <ExpandMore />}
                </TableCell>
              </TableRow>

              {expandedDays[dayIndex] && (
                <TableRow>

                  <TableCell colSpan={2} style={{ padding: 0 }}>
                    <Collapse
                      in={expandedDays[dayIndex]}
                      timeout="auto"
                      unmountOnExit
                    >
                    <Paper elevation={0} style={{ padding: 16,  margin: '12px 0' }}>
                      <Typography variant="subtitle1" gutterBottom style={{ marginBottom: 8,  fontWeight: 600 }}>
                        Asientos {day.date}
                       </Typography>
                      <Table size="small">
                        <TableHead>
                          <TableRow>
                            <TableCell className={classes.tableCell}>
                              Rut
                            </TableCell>
                            <TableCell className={classes.tableCell}>
                              Empresa
                            </TableCell>
                            <TableCell className={classes.tableCell}>
                              Asiento
                            </TableCell>
                            <TableCell></TableCell>
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          {day.groupedLinesByCategoryAndBusiness.map(
                            (category: any, catIndex: number) => (
                              <React.Fragment key={`${dayIndex}-${catIndex}`}>
                                <TableRow className={classes.clickableRow} onClick={() => handleRowClick(category)}>
                                  <TableCell className={classes.tableCell}>
                                    {category.businessIdentifier}
                                  </TableCell>
                                  <TableCell className={classes.tableCell}>
                                    {category.businessName}
                                  </TableCell>
                                  <TableCell className={classes.tableCell}>
                                    {category.category}
                                  </TableCell>
                                  <TableCell
                                    className={classes.tableCell}
                                    style={{ textAlign: 'right' }}
                                  >
                                  </TableCell>
                                </TableRow>
                              </React.Fragment>
                            ),
                          )}
                        </TableBody>
                      </Table>
                      </Paper>
                    </Collapse>
                  </TableCell>
                </TableRow>
              )}
            </React.Fragment>
          ))}
        </TableBody>
      </Table>
      <CategoryModal
        open={modalOpen}
        onClose={handleCloseModal}
        category={selectedCategory}
      />
    </TableContainer>
  );
};

export default DailyBookEntriesTable;
